import React, { useState } from 'react';

export const POSITIONS = {
	LEFT: 'LEFT',
	RIGHT: 'RIGHT',
	TOP: 'TOP',
	BOTTOM: 'BOTTOM'
};

const CustomTooltip = ({
	children, // JSX ex: <p>Content to be hovered...</p>
	text, // Plain Text (*String)
	arrowLeft, // Position of the arrow *Boolean
	arrowRight, // Position of the arrow *Boolean
	arrowCenter, // Position of the arrow *Boolean
	position = POSITIONS.TOP, // Any of the Value From the POSITIONS object
	background = '#000', // color code (*String)
	color = '#FFF', // color code (*String)
	className = ''
}) => {
	const [isHover, setIsHover] = useState(false);

	const getTooltipPositionStyles = () => {
		switch (position) {
			case POSITIONS.LEFT:
				return { top: '50%', left: '-115%', transform: 'translate(-50%, -50%)' };
			case POSITIONS.RIGHT:
				return { top: '50%', left: '115%', transform: 'translateY(-50%)' };
			case POSITIONS.BOTTOM:
				return {
					top: '30px',
					left: arrowLeft ? '0' : '50%',
					transform: arrowLeft ? '' : 'translateX(-50%)'
				};
			case POSITIONS.TOP:
			default:
				return {
					top: '-25px',
					left: arrowLeft ? '0' : '50%',
					transform: arrowLeft ? '' : 'translateX(-50%)'
				};
		}
	};

	const getArrowPositionStyles = () => {
		let arrowStyles = {
			position: 'absolute',
			width: '0',
			height: '0',
			borderStyle: 'solid',
			borderWidth: '8px'
		};

		switch (position) {
			case POSITIONS.RIGHT:
				return {
					...arrowStyles,
					top: '50%',
					left: '-16px',
					transform: 'translateY(-50%)',
					borderColor: `transparent ${background} transparent transparent`
				};
			case POSITIONS.LEFT:
				return {
					...arrowStyles,
					top: '50%',
					right: '-16px',
					transform: 'translateY(-50%)',
					borderColor: `transparent transparent transparent ${background}`
				};
			case POSITIONS.BOTTOM:
				return {
					...arrowStyles,
					top: '-60%',
					left: arrowCenter ? '50%' : arrowLeft ? '5%' : arrowRight ? '87%' : '',
					borderColor: `transparent transparent ${background} transparent`
				};
			case POSITIONS.TOP:
			default:
				return {
					...arrowStyles,
					bottom: '-59%',
					left: arrowCenter ? '50%' : arrowLeft ? '13%' : arrowRight ? '87%' : '',
					borderColor: `${background} transparent transparent transparent`
				};
		}
	};

	return (
		<div
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			style={{ position: 'relative' }}
		>
			{isHover && (
				<div
					className={className}
					style={{
						background: background,
						position: 'absolute',
						padding: '3px 7px 3px 7px',
						textAlign: 'center',
						width: 'auto',
						boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
						borderRadius: '2px',
						whiteSpace: 'nowrap',
						zIndex: '999',
						...getTooltipPositionStyles()
					}}
				>
					<div style={getArrowPositionStyles()}></div>
					<p style={{ margin: 0, fontSize: '13px', color: color }}>{text}</p>
				</div>
			)}
			<div>{children}</div>
		</div>
	);
};

export default CustomTooltip;
